import { View } from "binder"
import { ListViewModel } from "./list-viewModel"

export class ListView extends View<ListViewModel>{
    GetViewUniqueId(): string {
        return "V-E9A9961F-74A5-480E-86C9-DF54D666F4E7"
    }
    loadHtml(): string {
        let element = require('./list.html').default;
        let style = require('./list.less');
        return element;
    }
    constructor() {
       super();
    }
}
